"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageSendQueue = exports.Queue = void 0;
var message_classification_1 = require("./message-classification");
var room_channel_define_1 = require("../../../websocket-channel/room-channel-define");
var Queue = /** @class */ (function () {
    function Queue() {
        this.queue = [];
    }
    Queue.prototype.get = function (taskId) {
        var messages = this.queue.filter(function (message) { return message.taskId === taskId; });
        if (messages.length === 0) {
            return null;
        }
        return messages[0];
    };
    Queue.prototype.has = function (taskId) {
        return this.queue.some(function (message) { return message.taskId === taskId; });
    };
    Queue.prototype.add = function (message) {
        if (this.has(message.taskId)) {
            return;
        }
        this.queue.push(message);
    };
    Queue.prototype.remove = function (taskId) {
        var index = 0;
        for (; index < this.queue.length; index++) {
            var message = this.queue[index];
            if (message.taskId === taskId) {
                break;
            }
        }
        if (index === this.queue.length) {
            return null;
        }
        return this.queue.splice(index, 1)[0];
    };
    Queue.prototype.filter = function (predicate) {
        return this.queue.filter(predicate);
    };
    Queue.prototype.some = function (predicate) {
        return this.queue.some(predicate);
    };
    return Queue;
}());
exports.Queue = Queue;
var MessageSendQueue = /** @class */ (function () {
    function MessageSendQueue(messageClassification) {
        this.messageClassification = messageClassification;
        this.parallelQueue = new Queue();
        this.serialQueue = new Queue();
    }
    MessageSendQueue.prototype.isCommittingSerialMessage = function () {
        return this.serialQueue.some(function (message) { return message.state === room_channel_define_1.MessageState.SENDING; });
    };
    MessageSendQueue.prototype.nextSerialMessage = function () {
        var messages = this.serialQueue.filter(function (message) { return message.state === room_channel_define_1.MessageState.WAITING; });
        if (messages.length === 0) {
            return null;
        }
        return messages[0];
    };
    MessageSendQueue.prototype.nextParallelMessages = function () {
        return this.parallelQueue.filter(function (message) { return message.state === room_channel_define_1.MessageState.WAITING; });
    };
    MessageSendQueue.prototype.add = function (message) {
        var messageSendType = this.messageClassification.getMessageSendType(message.cmd);
        if (messageSendType === message_classification_1.MessageSendType.PARALLEL) {
            // 同步消息
            this.parallelQueue.add(message);
        }
        else {
            // 异步消息
            this.serialQueue.add(message);
        }
    };
    MessageSendQueue.prototype.remove = function (taskId) {
        if (this.parallelQueue.has(taskId)) {
            return this.parallelQueue.remove(taskId);
        }
        return this.serialQueue.remove(taskId);
    };
    MessageSendQueue.prototype.get = function (taskId) {
        if (this.parallelQueue.has(taskId)) {
            return this.parallelQueue.get(taskId);
        }
        return this.serialQueue.get(taskId);
    };
    MessageSendQueue.prototype.has = function (taskId) {
        return this.serialQueue.has(taskId) || this.parallelQueue.has(taskId);
    };
    MessageSendQueue.prototype.filter = function (predicate) {
        return __spread(this.parallelQueue.filter(predicate), this.serialQueue.filter(predicate));
    };
    MessageSendQueue.prototype.updateMessageState = function (state) {
        var _a;
        var messages = this.serialQueue.filter(function (message) { return message.state !== room_channel_define_1.MessageState.WAITING; }).concat(this.parallelQueue.filter(function (message) { return message.state !== room_channel_define_1.MessageState.WAITING; }));
        (_a = messages.forEach) === null || _a === void 0 ? void 0 : _a.call(messages, function (message) {
            message.state = state;
        });
    };
    return MessageSendQueue;
}());
exports.MessageSendQueue = MessageSendQueue;
